// src/data/PortfolioData.js
export const PROJECTS = [
  {
    id: "condo-solea-3-5",
    title: "Condo Soléa — 3 ½ ",
    cover: "/images/portfolio/solea.jpeg",
    media: [
      {
        type: "iframe",
        src: "https://kuula.co/share/hsCVF/collection/7Dxh4?logo=1&info=0&logosize=87&fs=1&vr=1&zoom=1&initload=0&autorotate=0.22&autopalt=1&thumbs=1",
      },
      {
        type: "iframe",
        src: "https://www.youtube.com/embed/5wsqZFM2Nrc?si=nRl3Jga-maq6uqpU",
      },
      { type: "image", src: "/images/portfolio/DSC01271.JPEG" },
      { type: "image", src: "/images/portfolio/DSC01314.JPEG" },
      { type: "image", src: "/images/portfolio/DSC01305.JPEG" },
      { type: "image", src: "/images/portfolio/DSC01332.JPEG" },
      { type: "image", src: "/images/portfolio/DSC01230.JPEG" },
      { type: "image", src: "/images/portfolio/DSC01255.JPEG" },
      { type: "image", src: "/images/portfolio/DSC01252.JPEG" },
      { type: "image", src: "/images/portfolio/DSC01335.JPEG" },
      { type: "image", src: "/images/portfolio/DSC01337.JPEG" },
      { type: "image", src: "/images/portfolio/DSC01286.JPEG" },
      { type: "image", src: "/images/portfolio/DSC01292.JPEG" },
    ],
    tags: ["360°", "Drone", "Video", "Photo"],
    location: "Montreal — Condo Solea",
    services: [
      "360° Virtual Tour",
      "Cinematic Drone Footage",
      "High-Impact Video",
      "Professional Photography",
    ],
    excerpt:
      "A complete visual marketing package for a modern 3 ½ condo in the Solea development. From immersive 360° tours to cinematic drone video, every angle was designed to attract buyers and drive faster conversions.",
    slug: "/portfolio/condo-solea-3-5",
  },
  {
    id: "airbnb-montreal-rental",
    title: "Beautiful Airbnb Rental — Montreal",
    cover: "/images/portfolio/Arbnb-Gaby.PNG",
    media: [
      {
        type: "iframe",
        src: "https://kuula.co/share/hslDD/collection/7DxbV?logo=1&info=0&logosize=87&fs=1&vr=1&zoom=1&initload=0&autorotate=0.22&autopalt=1&thumbs=1",
      },
      {
        type: "iframe",
        src: "https://youtube.com/shorts/6rL7hE7RS90?si=aceWVnXGRSaQvz6q",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-16-30.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-38-35.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-40-06.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-40-21.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-40-32.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-41-01.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-44-33.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-46-17.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/comedor.JPG",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-48-37.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-49-16.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-50-04.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-51-30.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-54-15.jpeg",
      },
      { type: "image", src: "/images/portfolio/DSC00135.JPG" },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-36-09.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-35-36.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-33-25.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-37-48.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-36-51.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/cuarto.JPG",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-12-24-58.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-26-41.jpeg",
      },
      {
        type: "image",
        src: "/images/portfolio/Facetune_24-09-2025-00-28-03.jpeg",
      },
    ],
    tags: ["360°", "Drone", "Video", "Photo"],
    location: "Montreal — Airbnb Rental Property",
    services: [
      "360° Virtual Tour",
      "Cinematic Drone Footage",
      "High-Impact Video",
      "Professional Photography",
    ],
    excerpt:
      "A full-service media package for a stylish Airbnb rental. Combining 360° tours, drone footage, video storytelling, and professional photography, we created a showcase designed to increase bookings and boost visibility on Airbnb.",
    slug: "/portfolio/airbnb-montreal-rental",
  },
  {
    id: "cinematic-house",
    title: "Modern Suburban Residence",
    cover: "/images/portfolio/cinematic-house.jpg",
    media: [
      {
        type: "iframe",
        src: "https://youtu.be/gXzdvWUUmuw?si=BFq9zQjuj600CF3j",
      },
    ],
    tags: ["Drone", "Video"],
    location: "Fabreville - Suburban Residence",
    services: ["Cinematic Drone Footage", "High-Impact Video"],
    excerpt:
      "A complete visual marketing showcase for a modern residence captured with cinematic precision. Every angle was designed to highlight the home’s unique character and elevate its market presence.",
    slug: "/portfolio/cinematic-house-montreal",
  },
];
